import { Option } from 'element-ui'

const YOption = Option
YOption.$depends = [Option]
YOption.$name = 'y-option'
YOption._name = 'Option 选择器选项'

export default YOption
